import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { KPEffectiveSignificator } from './KPEffectiveSignificator';

export function KPEffectiveSignificatorChart ({menuArray,userData}) {
  return(
    <>
      { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[3]} className="m-0 p-0 ">
              <Row id="planetSignificatorsChart" className="m-0 p-0">
                  <Col xs={12} lg={6} className="p-2 pt-0 m-0">
                    <KPEffectiveSignificator userData={userData}/>
                  </Col>
                  <Col xs={12} lg={6} className="p-2 pt-0 m-0">
                    
                  </Col>
              </Row>
          </Collapse>
    }
  </>  
  );
}